import { client } from './API';

export function changeNativeCommunity({ username, users }) {
  return client
    .post(`/api/members/${username}/native-community`, users)
    .then(response => response.data);
}
